import React, { useEffect, useRef } from 'react';

const THERAPY_ROOM = 'https://customer-assets.emergentagent.com/job_mindful-support-21/artifacts/3qv26w15_Therapy%20room.png';

export default function Background() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('visible')),
      { threshold: 0.1 }
    );
    const el = sectionRef.current;
    if (el) el.querySelectorAll('.reveal').forEach((node) => observer.observe(node));
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="background"
      className="relative py-24 lg:py-32 bg-[#FAF9F6]"
      data-testid="background-section"
      ref={sectionRef}
    >
      {/* Subtle watermark therapy room image (~20% opacity) */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-80 pointer-events-none"
        style={{ backgroundImage: `url(${THERAPY_ROOM})` }}
        aria-hidden="true"
      />
      {/* Semi-opaque overlay keeps text readable (WCAG AA) */}
      <div className="absolute inset-0 bg-[#FAF9F6]/70 pointer-events-none" aria-hidden="true" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="mb-10 reveal">
            <h2 className="font-heading text-4xl md:text-5xl text-[#2C362A] leading-tight">
              Background
            </h2>
          </div>

          <div className="space-y-6 font-body text-base md:text-lg text-[#5B6E56] leading-relaxed">
            <p className="reveal">
              I hold an MA in Person‑Centred Counselling, along with postgraduate training in relationship mentoring and a diploma in communication. I am a registered member of the Irish Association for Counselling &amp; Psychotherapy (IACP) and am committed to ongoing learning and professional development.
            </p>
            <p className="reveal">
              Before becoming a psychotherapist, I spent over twenty years working in nursing and public health. During that time, I supported people through some of their most vulnerable moments, developing a deep understanding of how our histories, environments, and relationships shape us. These experiences continue to inform the care, sensitivity, and depth I bring to my work.
            </p>
            <p className="reveal">
              I support individuals across a wide range of experiences, including navigating life transitions, identity exploration, burnout, building assertiveness, grief and loss, fostering creativity, trauma and PTSD, social anxiety, building resilience, suicidality, and neurodiversity.
            </p>
          </div>

          {/* Quote */}
          <div className="mt-14 reveal">
            <blockquote className="relative text-center">
              <p className="font-heading text-2xl md:text-3xl lg:text-4xl text-[#2C362A] italic font-light leading-snug px-8">
                In being heard, something in you can begin to heal
              </p>
              <div className="mt-6 flex items-center justify-center gap-3">
                <span className="h-px w-8 bg-[#D1D8D0]" />
                <span className="font-body text-xs text-[#708A72]">&copy; Donna Gordon</span>
                <span className="h-px w-8 bg-[#D1D8D0]" />
              </div>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
}
